module.exports = __webpack_public_path__ + "img/image1.671d799e.png";